/* eslint-disable import/no-named-as-default-member */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { useFetchQuery } from './useFetchQuery'
import { FormParticipant as FormParticipantApi } from '../API'
import { formParticipantsByParticipantIdAndCreatedAt } from '../api/queries'
import { fetchQuery } from '../utils/ApiUtils'

type FormParticipant = Omit<Exclude<FormParticipantApi, null>, '__typename'>

interface Props {
  eventId: string
  participantId: string
}
const useFormParticipantDetails = ({ eventId, participantId }: Props) => {
  const {
    data: participant,
    apiLoading,
    apiError,
  } = useFetchQuery(
    async () => {
      const { items } = (await fetchQuery(
        'formParticipantsByParticipantIdAndCreatedAt',
        formParticipantsByParticipantIdAndCreatedAt,
        {
          participantId,
          filter: { formEventId: { eq: eventId } },
          sortDirection: 'DESC',
        },
      )) as unknown as { items: FormParticipant[] }

      if (items.length > 0) {
        const item = items[0]
        if (item.participantId === participantId) {
          item.tshirtCount = JSON.parse(JSON.parse(item.tshirtCount))
          return item
        }
      }
      return null
    },
    [eventId, participantId],
    'Fail to retrieve data',
    { initialValue: null, guard: !!participantId, onBeforeFetch: () => {} },
  )

  return { participant, apiLoading, apiError }
}

export default useFormParticipantDetails
